import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { moderateScale } from 'react-native-size-matters';
import { StyleSheet, View, TouchableOpacity, Dimensions } from 'react-native';
import { Icon, Heading, HeadingTypes } from '../../components';
import Theme from '../../theme';
import { ActionPanel } from './ActionPanel';
import { isLarge } from '../../utils/ScreenSizes';
const width = Dimensions.get('window').width;
const isMobileWeb = width <= 550;

const BaseModal = ({
  title,
  onShow,
  showHeader = true,
  children,
  bodyStyle,
  closeModal,
  isModalVisible,
  headerTextStyle,
  closeDisabled = false,
  forcePopup,
  size,
  subtitle = null,
  containerStyle,
  applyRightPadding = true,
  useFullWidth = false,
  hideCloseButton = false,
}) => {
  const close = () => {
    if (!closeDisabled) {
      closeModal();
    }
  };
  return (
    <ActionPanel
      size={size}
      transparent
      onShow={onShow}
      animationType="fade"
      visible={isModalVisible}
      onRequestClose={close}
      forcePopup={forcePopup}>
      <View
        keyboardShouldPersistTaps="handled" style={[containerStyle, styles.modalContainer]}>
        <View
          style={[styles.innerModalContainer, bodyStyle]}>
          { showHeader && <View style={[styles.headerTextStyle, headerTextStyle]}>
            <View style={styles.header}>
              <View style={styles.topHeader}>
                <Heading
                  title={title}
                  headerType={HeadingTypes.HEADING_ONE}
                  style={styles.headerText}
                />
              </View>
              {!hideCloseButton &&
              <TouchableOpacity
                disabled={closeDisabled}
                onClick={close}>
                <Icon
                  size={30}
                  name="md-close"
                  color={Theme.GREY}
                  style={styles.icon}
                />
              </TouchableOpacity>}
            </View>
            {subtitle}
          </View>}
          <View style={[
            styles.bodyContainer,
            applyRightPadding && isLarge && styles.bodyPaddingOnLargeScreen, useFullWidth ? { paddingLeft: 0, paddingRight: 0 } : {}]}>
            {children}
          </View>
        </View>
      </View>
    </ActionPanel>
  );
};

BaseModal.propTypes = {
  onShow: PropTypes.func,
  title: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  isModalVisible: PropTypes.bool.isRequired,
  bodyStyle: PropTypes.object,
  headerTextStyle: PropTypes.object,
  closeDisabled: PropTypes.bool,
};

const styles = StyleSheet.create({
  modalContainer: {
    maxHeight: isMobileWeb ? window.innerHeight : '91vh',
    position: isMobileWeb ? 'fixed' : undefined,
    width: isMobileWeb ? '100%' : undefined,
  },
  innerModalContainer: {
    flex: 1,
    paddingVertical: 15,
    paddingHorizontal: 15,
    backgroundColor: 'white',
  },
  headerTextStyle: {
    paddingBottom: 10,
    borderBottomWidth: 2,
    borderBottomColor: Theme.GREY_LIGHT,
  },
  headerText: {
    color: Theme.CHARCOAL,
    fontSize: moderateScale(22, 1),
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  icon: {
    lineHeight: 30,
  },
  bodyContainer: {
    flex: 1,
  },
  bodyPaddingOnLargeScreen: {
    paddingTop: '2%',
    paddingLeft: '5%',
    paddingRight: '30%',
  },
  topHeader: {
    flex: 1,
  },
});

export default translate(['home'], { wait: true })(BaseModal);
